const types = {
  HIDE_UNDO_TOAST: 'HIDE_UNDO_TOAST',
  LAUNCH_UNDO_TOAST: 'LAUNCH_UNDO_TOAST',
}

export default types
